/** 首页 Plus 输入框 → 节点画布：一次性创建节点并执行 */
export const CANVAS_NODE_HANDOFF_KEY = 'ngc_home_node_handoff'

/**
 * @param {{
 *   nodeType?: string,
 *   prompt?: string,
 *   contentPlain?: string,
 *   style?: object|null,
 *   autoRun?: boolean
 * }} payload
 */
export function saveCanvasNodeHandoff(payload) {
  try {
    const prompt =
      payload && payload.prompt != null
        ? String(payload.prompt)
        : payload && payload.contentPlain != null
          ? String(payload.contentPlain)
          : ''
    sessionStorage.setItem(
      CANVAS_NODE_HANDOFF_KEY,
      JSON.stringify({
        nodeType: payload && payload.nodeType != null ? String(payload.nodeType) : '',
        prompt: prompt.trim(),
        contentPlain: prompt.trim(),
        style: payload && payload.style ? payload.style : null,
        autoRun: payload && payload.autoRun === false ? false : true
      })
    )
    return true
  } catch (e) {
    return false
  }
}

/** @returns {object|null} */
export function consumeCanvasNodeHandoff() {
  try {
    const raw = sessionStorage.getItem(CANVAS_NODE_HANDOFF_KEY)
    sessionStorage.removeItem(CANVAS_NODE_HANDOFF_KEY)
    if (!raw) return null
    const data = JSON.parse(raw)
    if (!data || typeof data !== 'object') return null
    return data
  } catch (e) {
    try {
      sessionStorage.removeItem(CANVAS_NODE_HANDOFF_KEY)
    } catch (err) {
      /* ignore */
    }
    return null
  }
}
